import isArray from 'lodash/isArray';

export const getHasFilterParams = (params: Record<string, string | string[] | undefined>) =>
    Object.values(params).some((filter) => {
        if (isArray(filter)) {
            return Boolean(filter.length);
        } else {
            return Boolean(filter);
        }
    });
